import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

const PrivateRoute = () => {
  const location = useLocation();
  
  // 获取当前URL中的inviteCode参数
  const searchParams = new URLSearchParams(location.search);
  const inviteCode = searchParams.get('inviteCode');

  if (!isAuthenticated()) {
    // 构建重定向URL，如果有inviteCode则带上
    const redirectPath = inviteCode 
      ? `/campaigns/invitations/signup-invite-code?inviteCode=${inviteCode}`
      : '/campaigns/invitations/refer-and-earn';

    // 将用户重定向到登录页面，但保存他们试图访问的位置和邀请码
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute; 